var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartReaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 110.027,
    viewBox: "0 0 125 110.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21773",
    "data-name": "\\u30D1\\u30B9 21773",
    d: "M349,306.379v5.8a6.225,6.225,0,0,0-.868,1.69c-2.354,14.574-9.221,27-18.546,38.2a120.437,120.437,0,0,1-37.318,30.5c-4.1,2.122-7.768,2.4-11.648-.046-5.606-3.535-11.6-6.584-16.759-10.676-18.916-15.006-34.149-32.633-38.894-57.227A5.655,5.655,0,0,0,224,313v-9.937c.581-1.464,1.276-2.894,1.725-4.4,6.949-23.244,35.525-32.011,54.382-16.624,2.3,1.879,4.352,4.067,6.568,6.158l1.257-1.421c9.341-10.545,21.045-14.842,34.736-11.378,13.464,3.407,21.81,12.462,25.084,25.976C348.156,303.05,348.583,304.713,349,306.379Z",
    transform: "translate(-224 -274.228)",
    fill: "#ff36a2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartReaction);
export default __webpack_public_path__ + "static/media/heartReaction.cb24faaf6738617cf5f1e09e8979d866.svg";
export { ForwardRef as ReactComponent };